// extracted by mini-css-extract-plugin
export default {"personInfo":"DropText_personInfo__eJc7o","arrowIcon":"DropText_arrowIcon__wSuqa"};